//
import { createSelector, createStructuredSelector } from "reselect"

export const selectAssignmentSlice = (state) => state.assignment
export const selectDatumId = (state, props) => props.datumId
export const selectModel = (state, props) => props.model

// assignments selector for profile AssignmentAdders

export const selectAssignments = createSelector(
    selectAssignmentSlice,
    selectModel,
    selectDatumId,
    (slice, model, datumId) => {
        const assignments = slice.get(String(model) + String(datumId))
        return assignments ? assignments.toJS() : []
    },
)

// assignments selectors for adding/changing assignments Contact/Org create/edit form

export const selectFutureAssignments = createSelector(selectAssignmentSlice, (slice) =>
    slice.get("futureAssignments").toJS(),
)

export const selectInitialAssignments = createSelector(selectAssignmentSlice, (slice) =>
    slice.get("initialAssignments").toJS(),
)

export const selectFinalAssignments = createSelector(selectAssignmentSlice, (slice) =>
    slice.get("finalAssignments").toJS(),
)

export const selectFutureUserAssignments = createSelector(selectAssignmentSlice, (slice) =>
    slice.getIn(["futureAssignments", `${DjangIO.app.models.QuorumDataType.user.value}`]).toJS(),
)

export const selectFutureSupporterAssignments = createSelector(selectAssignmentSlice, (slice) =>
    slice.getIn(["futureAssignments", `${DjangIO.app.models.QuorumDataType.supporter.value}`]).toJS(),
)

export const selectFinalUserAssignments = createSelector(selectAssignmentSlice, (slice) =>
    slice.getIn(["finalAssignments", `${DjangIO.app.models.QuorumDataType.user.value}`]).toJS(),
)

export const selectFinalSupporterAssignments = createSelector(selectAssignmentSlice, (slice) =>
    slice.getIn(["finalAssignments", `${DjangIO.app.models.QuorumDataType.supporter.value}`]).toJS(),
)

export const selectLoading = createSelector(selectAssignmentSlice, (slice) => slice.get("loading"))

export const selectOwnershipError = createSelector(selectAssignmentSlice, (slice) => slice.get("ownershipError"))

export const selectUserIsAnAssignmentRecipient = createSelector(
    selectAssignments,
    (assignments) =>
        assignments &&
        assignments.find((assignment) => assignment.recipient && assignment.recipient.id === Userdata.id),
)

export const selectNoResultsType = (_, props) =>
    props.isEU
        ? "Legislation"
        : props.label || (props.model && DjangIO.app.models.QuorumDataType.by_value(props.model).singular)

export const selectIconForUserCheckBox = createSelector(
    selectUserIsAnAssignmentRecipient,
    (userIsARecipient) => `fa fa-${userIsARecipient ? "check-" : ""}square-o`,
)

export const assignmentAdderConnection = createStructuredSelector({
    assignments: selectAssignments,
    futureAssignments: selectFutureAssignments,
    initialAssignments: selectInitialAssignments,
    finalAssignments: selectFinalAssignments,
    futureUserAssignments: selectFutureUserAssignments,
    futureSupporterAssignments: selectFutureSupporterAssignments,
    finalUserAssignments: selectFinalUserAssignments,
    finalSupporterAssignments: selectFinalSupporterAssignments,
    loading: selectLoading,
    noResultsType: selectNoResultsType,
    ownershipError: selectOwnershipError,
    userIsARecipient: selectUserIsAnAssignmentRecipient,
    iconForUserCheckBox: selectIconForUserCheckBox,
})
